import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Button, Grid } from '@material-ui/core';
import MapIcon from '@material-ui/icons/Room';

import MobileDeliveryConsigneeDelayDialog from './dialogs/MobileDeliveryConsigneeDelayDialog';
import MobileDeliveryEnterProductDialog from './dialogs/MobileDeliveryEnterProductDialog';
import MobileDeliveryEnterTimeDialog from './dialogs/MobileDeliveryEnterTimeDialog';
import MobileDeliveryScanDocumentsDialog from './dialogs/MobileDeliveryScanDocumentsDialog';
import AuthUserContainer from '../../../containers/AuthUser';

import MobileDeliveryRackDelayDialog from './dialogs/MobileDeliveryRackDelayDialog';
import MobileDeliveryCommodities from './MobileDeliveryCommodities';
import MobileDeliveryNotes from './MobileDeliveryNotes';
import {
	convertEventTypeToDisplay,
	ENTER_TIME_EVENT_TYPE,
	MobileDeliveryCommodityProduct,
	STL_BLUE,
	STOP_STATUS,
	stopStatusToBadgeStyle,
	stopStatusToDisplay,
	toNum,
} from './util';

class MobileDeliveryLoadStop extends Component {
	constructor(props) {
		super(props);

		let isConsigneeDelayOpen = false;
		const currentUrl = window.location.href;
		if (currentUrl.includes('showConsignee')) {
			isConsigneeDelayOpen = true;
		}

		let isScanDocumentsOpen = false;
		if (currentUrl.includes('showScanDocuments')) {
			isScanDocumentsOpen = true;
		}

		this.state = {
			isRackDelayOpen: false,
			isConsigneeDelayOpen,
			isEnterProductOpen: false,
			isShowErrorDialogOpen: false,
			isEnterTimeDialogOpen: false,
			isScanDocumentsOpen,
			enterTimeDialogEventType: ENTER_TIME_EVENT_TYPE.ARRIVAL,
			enterTimeDialogDateTime: undefined,
		};
	}

	showRackDelayMobile = () => {
		this.setState({ isRackDelayOpen: true });
	};
	closeRackDelayMobile = () => {
		this.setState({
			isRackDelayOpen: false,
		});
	};

	showConsigneeDelayMobile = () => {
		this.setState({ isConsigneeDelayOpen: true });
	};
	closeConsigneeDelayMobile = () => {
		this.setState({
			isConsigneeDelayOpen: false,
		});
	};

	showEnterProductDialog = () => {
		this.setState({ isEnterProductOpen: true });
	};
	closeEnterProductDialog = () => {
		this.setState({
			isEnterProductOpen: false,
		});
	};

	showEnterArrivalTimeDialog = () => {
		const { stop } = this.props;
		const shouldUpdateArrival = stop.stopStatus === STOP_STATUS.DNE;
		const stopArrivalDateTime = shouldUpdateArrival
			? moment(stop.stopArrivalDate).format('YYYY-MM-DD HH:mm:ss')
			: undefined;

		this.showEnterTimeDialog({
			eventType: ENTER_TIME_EVENT_TYPE.ARRIVAL,
			eventDateTime: stopArrivalDateTime,
		});
	};

	showEnterDepartureTimeDialog = () => {
		const { stop } = this.props;
		const shouldUpdateDeparture = stop.stopDepartureStatus === STOP_STATUS.DNE;
		const stopDepartureDateTime = shouldUpdateDeparture
			? moment(stop.stopDepartureDate).format('YYYY-MM-DD HH:mm:ss')
			: undefined;

		this.showEnterTimeDialog({
			eventDateTime: stopDepartureDateTime,
			eventType: ENTER_TIME_EVENT_TYPE.DEPARTURE,
		});
	};

	showEnterTimeDialog = ({ eventDateTime, eventType }) => {
		this.setState({
			enterTimeDialogDateTime: eventDateTime,
			enterTimeDialogEventType: eventType,
			isEnterTimeDialogOpen: true,
		});
	};
	closeEnterTimeDialog = () => {
		this.setState({
			enterTimeDialogDateTime: undefined,
			enterTimeDialogEventType: undefined,
			isEnterTimeDialogOpen: false,
		});
	};

	openScanDocuments = () => {
		this.setState({
			isScanDocumentsOpen: true,
		});
	};
	closeScanDocuments = () => {
		this.setState({
			isScanDocumentsOpen: false,
		});
	};

	render() {
		//const { stop, deliveryTicket, classes, permissionMap } = this.props;
		const { stop, deliveryTicket, classes } = this.props;
		const { isRackDelayOpen, isConsigneeDelayOpen, isEnterProductOpen } = this.state;
		if (!stop) {
			return null;
		}

		//cons/t showScanFeature = permissionMap ? permissionMap.canBetaBolScanning : false;
		const showScanFeature = true; //permissionMap ? permissionMap.canBetaBolScanning : false;
		let isArriveDisabled = true;
		let reasonArriveIsDisabled = 'Only enabled for BETA users.';

		let isDepartDisabled = true;
		let reasonDepartIsDisabled = 'Only enabled for BETA users.';

		let isRackDelayDisabled = false;
		let isEnterProductDisabled = false;

		// Turn on for BETA users
		isArriveDisabled = false;
		reasonArriveIsDisabled = null;
		isDepartDisabled = false;
		reasonDepartIsDisabled = null;

		// stop status === arrival status
		if (stop.stopStatus !== STOP_STATUS.DNE) {
			isDepartDisabled = true;
			reasonDepartIsDisabled = 'Arrival status is not "Done". You must arrive first.';
		}

		// First we check for prev trip / stops disabled
		if (stop.disabledArriveAndDepartReason) {
			isArriveDisabled = isDepartDisabled = true;
			reasonArriveIsDisabled = reasonDepartIsDisabled = stop.disabledArriveAndDepartReason;
		}

		if (deliveryTicket.disabledArriveAndDepartReason) {
			isArriveDisabled = isDepartDisabled = true;
			reasonArriveIsDisabled = reasonDepartIsDisabled =
				deliveryTicket.disabledArriveAndDepartReason;
		}

		if (stop.stopIsForAnotherDriver) {
			isArriveDisabled = isDepartDisabled = true;
			reasonArriveIsDisabled = reasonDepartIsDisabled = 'Stop is for a different driver';
			isRackDelayDisabled = isEnterProductDisabled = true;
		}

		const showDisabled = !!reasonArriveIsDisabled || !!reasonDepartIsDisabled;

		const shouldUpdateArrival = stop.stopStatus === STOP_STATUS.DNE;
		const shouldUpdateDeparture = stop.stopDepartureStatus === STOP_STATUS.DNE;

		const stopArrivalDateTime = shouldUpdateArrival
			? moment(stop.stopArrivalDate).format('M/D HH:mm')
			: null;

		const stopDepartureDateTime = shouldUpdateDeparture
			? moment(stop.stopDepartureDate).format('M/D HH:mm')
			: null;

		const isPickup = stop.stopType === 'PUP';

		return (
			<div className={classes.loadContainer}>
				{isPickup && (
					<>
						<MobileDeliveryRackDelayDialog
							open={isRackDelayOpen}
							onClose={this.closeRackDelayMobile}
							tmwOrderId={deliveryTicket?.tmwOrderId}
							stopNumber={stop.stopNumber}
							delays={stop.delays}
						/>

						<MobileDeliveryEnterProductDialog
							open={isEnterProductOpen}
							onClose={this.closeEnterProductDialog}
							commodities={deliveryTicket.commodities}
							tmwOrderId={deliveryTicket?.tmwOrderId}
							stopNumber={stop.stopType === 'DRP' ? stop.stopNumber : null}
						/>
					</>
				)}
				{!isPickup && (
					<MobileDeliveryConsigneeDelayDialog
						open={isConsigneeDelayOpen}
						onClose={this.closeConsigneeDelayMobile}
						tmwOrderId={deliveryTicket?.tmwOrderId}
						stopNumber={stop.stopNumber}
						delays={stop.delays}
					/>
				)}

				<MobileDeliveryEnterTimeDialog
					open={this.state.isEnterTimeDialogOpen}
					onClose={this.closeEnterTimeDialog}
					eventType={this.state.enterTimeDialogEventType}
					eventDateTime={this.state.enterTimeDialogDateTime}
					tmwOrderId={deliveryTicket?.tmwOrderId}
					moveNumber={deliveryTicket?.moveNumber}
					stopNumber={stop?.stopNumber}
					setFetching={this.props.setFetching}
					getDeliveryTickets={this.props.getDeliveryTickets}
				/>
				<MobileDeliveryScanDocumentsDialog
					open={this.state.isScanDocumentsOpen}
					onClose={this.closeScanDocuments}
					tmwOrderId={deliveryTicket?.tmwOrderId}
					stopNumber={stop.stopNumber}
					scannedDocuments={deliveryTicket?.scannedDocuments}
				/>

				<div>
					<div style={{ display: 'flex' }}>
						<div className={classes.stopIcon}>
							<div>
								<MapIcon style={{ fontSize: '310%' }} />
							</div>
							<div className={classes.stopType}>{convertEventTypeToDisplay(stop.stopType)}</div>
						</div>
						<div>
							<div style={{ fontSize: '120%' }}>{stop.consigneeId}</div>
							<div style={{ lineHeight: 1.2, marginTop: 5 }}>
								<div>{stop.stopAddress}</div>
								<div>
									{stop.stopCity} {stop.stopState}, {stop.stopZip}
								</div>
							</div>

							<div style={{ lineHeight: 1.2, marginTop: 5, fontSize: '80%' }}>
								<div>Estimated Drive Time: {stop.estimatedDriveTime}</div>
								<div>Mileage: {stop.legMileage}</div>

								<div>
									<span className={classes.tickerLabel}>Status:</span>{' '}
									<span
										style={{
											...stopStatusToBadgeStyle(stop.stopStatus, stop.stopDepartureStatus),
											fontSize: '70%',
											borderRadius: '2vw',
											paddingLeft: '1vw',
											paddingRight: '1vw',
											paddingTop: '.3vw',
											paddingBottom: '.3vw',
											textTransform: 'uppercase',
											fontWeight: 500,
										}}
									>
										{stopStatusToDisplay(stop.stopStatus, stop.stopDepartureStatus)}
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>

				<MobileDeliveryNotes
					shipperNotes={deliveryTicket.shipperNotes}
					consigneeNotes={deliveryTicket.consigneeNotes}
					orderRemark={deliveryTicket.orderRemark}
					classes={classes}
					sectionTitle={'Notes & Remarks'}
				/>

				<div className={classes.productTitle}>Loading Numbers</div>
				{deliveryTicket.loadingNumber ? (
					<div style={{ fontSize: '90%' }}>{deliveryTicket.loadingNumber}</div>
				) : (
					<div className={classes.emptyNotes} style={{ fontSize: '90%' }}>
						Loading numbers empty (check notes)
					</div>
				)}

				<div className={classes.productTitle}>Actions</div>
				<div>
					<Grid container spacing={0}>
						<Grid item xs={6} style={{ textAlign: 'center' }}>
							{showDisabled && (
								<div className={classes.disabledReason}>{reasonArriveIsDisabled}&nbsp;</div>
							)}
							<Button
								className={classes.stopButton}
								style={{
									color: isArriveDisabled ? 'auto' : shouldUpdateArrival ? STL_BLUE : 'white',
								}}
								variant={
									isArriveDisabled ? 'contained' : shouldUpdateArrival ? 'outlined' : 'contained'
								}
								color="primary"
								aria-label="refresh"
								disabled={isArriveDisabled}
								onClick={this.showEnterArrivalTimeDialog}
							>
								{shouldUpdateArrival ? 'Update Arrival' : 'Arrive at Stop'}
							</Button>

							{!!stopArrivalDateTime && (
								<div className={classes.arrivalDepartureTime}>
									<div
										className={classes.greenCheckedIcon}
										style={{
											width: '2.5vw',
											height: '2.5vw',
											marginTop: '-.5vw',
											marginLeft: '-2vw',
											marginRight: '.5vw',
										}}
									/>
									<span>Arrived: {stopArrivalDateTime}</span>
								</div>
							)}
						</Grid>
						<Grid item xs={6} style={{ textAlign: 'center' }}>
							{showDisabled && (
								<div className={classes.disabledReason}>{reasonDepartIsDisabled}&nbsp;</div>
							)}
							<Button
								className={classes.stopButton}
								style={{
									color: isDepartDisabled ? 'auto' : shouldUpdateDeparture ? STL_BLUE : 'white',
								}}
								variant={
									isDepartDisabled ? 'contained' : shouldUpdateDeparture ? 'outlined' : 'contained'
								}
								color="primary"
								aria-label="refresh"
								disabled={isDepartDisabled}
								onClick={this.showEnterDepartureTimeDialog}
							>
								{shouldUpdateDeparture ? 'Update Departure' : 'Depart Stop'}
							</Button>

							{!!stopDepartureDateTime && (
								<div className={classes.arrivalDepartureTime}>
									<div
										className={classes.greenCheckedIcon}
										style={{
											width: '2.5vw',
											height: '2.5vw',
											marginTop: '-.5vw',
											marginLeft: '-2vw',
											marginRight: '.5vw',
										}}
									/>
									<span>Departed: {stopDepartureDateTime}</span>
								</div>
							)}
						</Grid>

						{isPickup && (
							<>
								<Grid item xs={6} style={{ textAlign: 'center', marginTop: '2vw' }}>
									<Button
										className={classes.stopButton}
										variant="contained"
										color="primary"
										aria-label="refresh"
										onClick={this.showRackDelayMobile}
										disabled={isRackDelayDisabled}
									>
										Rack Delay
									</Button>
								</Grid>
								<Grid item xs={6} style={{ textAlign: 'center', marginTop: '2vw' }}>
									<Button
										className={classes.stopButton}
										variant="contained"
										color="primary"
										aria-label="refresh"
										onClick={this.showEnterProductDialog}
										disabled={isEnterProductDisabled}
									>
										Enter Product
									</Button>
								</Grid>
							</>
						)}

						{!isPickup && (
							<>
								<Grid item xs={6} style={{ textAlign: 'center', marginTop: '2vw' }}>
									<Button
										className={classes.stopButton}
										variant="contained"
										color="primary"
										aria-label="refresh"
										onClick={this.showConsigneeDelayMobile}
									>
										Consignee Delay
									</Button>
								</Grid>
								<Grid item xs={6} style={{ textAlign: 'center', marginTop: '2vw' }}>
									<Button
										className={classes.stopButton}
										variant="contained"
										color="primary"
										aria-label="refresh"
										onClick={this.showEnterProductDialog}
										disabled={true}
									>
										Enter Product
									</Button>
								</Grid>
							</>
						)}

						<Grid item xs={6} style={{ textAlign: 'center', marginTop: '2vw' }}>
							<Button
								className={classes.stopButton}
								variant="contained"
								color="primary"
								aria-label="refresh"
								disabled={showScanFeature ? false : true}
								onClick={this.openScanDocuments}
							>
								Scan Documents
							</Button>
						</Grid>

						<Grid item xs={6} style={{ textAlign: 'center', marginTop: '2vw' }}>
							<Button
								className={classes.stopButton}
								variant="contained"
								color="primary"
								aria-label="refresh"
								disabled={true}
							>
								ENTER RETAIN
							</Button>
						</Grid>
					</Grid>
				</div>

				<MobileDeliveryCommodities
					commodities={deliveryTicket.commodities}
					classes={classes}
					stopNumber={stop.stopType === 'DRP' ? stop.stopNumber : null}
				/>

				<div className={classes.productTitle}>Consignee Tanks</div>
				<div>
					<Grid container>
						<Grid item xs={8} style={{ textAlign: 'center' }}>
							<table className={classes.gridTable}>
								<tbody>
									<tr className={classes.rowTr}>
										<td className={classes.tankRowHeader} style={{ textAlign: 'left' }}>
											Product
										</td>
										<td className={classes.tankRowHeader} style={{ textAlign: 'right' }}>
											Size
										</td>
										<td className={classes.tankRowHeader} style={{ textAlign: 'right' }}>
											Safe Fill
										</td>
									</tr>
									{deliveryTicket.consigneeTanks.map((tank, i) => {
										const { tankSize, ullage, cmdCode } = tank;
										return (
											<tr key={i} className={classes.rowTr}>
												{/* 
												
												<td className={classes.tankRow} style={{ width: '4%', textAlign: 'right' }}>
													{i + 1}
												</td>
											*/}
												<td className={classes.tankRow} style={{ textAlign: 'left' }}>
													<MobileDeliveryCommodityProduct cmdCode={cmdCode} />
												</td>
												<td className={classes.tankRow} style={{ textAlign: 'right' }}>
													{toNum(tankSize)}
												</td>
												<td className={classes.tankRow} style={{ textAlign: 'right' }}>
													{toNum(ullage)}
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</Grid>
					</Grid>
				</div>
			</div>
		);
	}
}

MobileDeliveryLoadStop.propTypes = {
	history: PropTypes.object.isRequired,
	deliveryTicket: PropTypes.object,
	getDeliveryTickets: PropTypes.func.isRequired,
	setFetching: PropTypes.func.isRequired,
	authUser: PropTypes.object,
};

export default _.flow([AuthUserContainer])(MobileDeliveryLoadStop);
